define('viewmodels/modals/dialogs/FaqDialogTablet',['knockout', 'underscore'], function (ko, _) {

    var FaqDialogTablet = function(dialog, questionAndAnswer, index) {
        var self = this;

        this.dialog = dialog;
        this.answer = questionAndAnswer.answer;
        this.question = questionAndAnswer.question;
        this.questionNumber = index + 1;
    };


    FaqDialogTablet.prototype.close = function() {
        this.dialog.close(this);
    };

    return FaqDialogTablet;
});

